import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { CardContent, Grid, Typography } from "@mui/material";
import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import { AdminButton } from "../../components/adminbutton/AdminButton";
import AdminTable from "../../components/admintable/AdminTable";
import Layout from "../../components/layout/Layout";
import Loading from "../../components/loading/Loading";
import { routes } from "../../config/routes";
import {
  getTablesAsync,
  recycleTableAsync,
  selectAllTables,
  selectTableStatus,
} from "../../features/tables/tablesSlice";
import Item from "../../../models/Item.model";
import RouteItem from "../../../models/RouteItem.model";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import EdisonCard from "../../../app-shared/edison/card/EdisonCard";
import getItemListColumns from "../../utils/getItemsListColumns";
import navigate from "../../utils/navigate";
import "./tables.scss";

const Tables: FC = () => {
  const { t } = useTranslation(["admin"]);

  const { url } = useRouteMatch();
  const history = useHistory();
  const dispatch = useAppDispatch();

  const list = useAppSelector(selectAllTables);
  const tablesStatus = useAppSelector(selectTableStatus);

  useEffect(() => {
    if (tablesStatus === "idle") {
      dispatch(getTablesAsync());
    }
  }, []);

  const deleteRow = async (ids: number[]) => {
    ids.forEach((id: number) => dispatch(recycleTableAsync(id)));
  };
  const editRow = async (ids: number[]) => {
    navigate(`/admin/tables/edittable`, history, {
      title: t("editTable"),
      item: list.find((item: Item) => item.id === ids[0]),
    });
  };

  const route = routes.find(
    (routeToFind: RouteItem) => routeToFind.key == "newtable"
  );
  return (
    <Layout>
      <div className="tables-page-root">
        <EdisonCard>
          <Grid container spacing={8}>
            <Grid item>
              <AdminButton
                pathName={!!route ? route.path : `${url}/newtable`}
                title={t("newTable")}
                buttonText={t("createTable")}
                configuration={list}
              />
            </Grid>
          </Grid>
        </EdisonCard>

        {tablesStatus !== "loading" ? (
          <Grid item xs={12}>
            <EdisonCard>
              <CardContent>
                {tablesStatus === "idle" ? (
                  list.length > 0 ? (
                    <AdminTable
                      data={list}
                      columns={getItemListColumns(t)}
                      editAction={editRow}
                      deleteAction={deleteRow}
                      icons={[
                        { icon: EditIcon, action: editRow },
                        { icon: CancelOutlinedIcon, action: deleteRow },
                      ]}
                    />
                  ) : (
                    <Grid className="centered">
                      <Typography variant="caption">
                        {t("noDataErrorMessage")}
                      </Typography>
                    </Grid>
                  )
                ) : (
                  <Typography variant="body1">
                    {t("loadingErrorMessage")}
                  </Typography>
                )}
              </CardContent>
            </EdisonCard>
          </Grid>
        ) : (
          <Loading />
        )}
      </div>
    </Layout>
  );
};
export default Tables;
